var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditImageBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2857 5H2.71429C2.3198 5 2 5.30526 2 5.68182V19.3182C2 19.6947 2.3198 20 2.71429 20H21.2857C21.6802 20 22 19.6947 22 19.3182V5.68182C22 5.30526 21.6802 5 21.2857 5ZM8.11111 7.14286C9.03159 7.14286 9.77778 7.8624 9.77778 8.75C9.77778 9.6376 9.03159 10.3571 8.11111 10.3571C7.19064 10.3571 6.44444 9.6376 6.44444 8.75C6.44444 7.8624 7.19064 7.14286 8.11111 7.14286ZM19.7025 16.4039C19.5809 16.638 19.3284 16.7862 19.052 16.7857H6.04319C5.7652 16.785 5.51229 16.6339 5.39275 16.3971C5.28938 16.1717 5.32251 15.9112 5.47948 15.7153L8.37033 12.3062C8.4933 12.1606 8.67405 12.0687 8.8706 12.052C9.06715 12.0352 9.26241 12.0951 9.41104 12.2175L10.5818 13.1857L13.4149 9.55846C13.5514 9.38678 13.7656 9.28571 13.993 9.28571C14.2193 9.28412 14.4332 9.38252 14.5712 9.55164L19.6302 15.688C19.7966 15.8943 19.8246 16.1717 19.7025 16.4039Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageBtn);
export default __webpack_public_path__ + "static/media/edit_image_btn.9441b36c930fb05ec93ac92f239c0688.svg";
export { ForwardRef as ReactComponent };